module.exports = __webpack_public_path__ + "static/media/a1.c0596539.png";